export default "__VITE_ASSET__C9yBG0wj__"